/**
 * pdf.js loader — VENDORED (public/vendor/pdfjs-3.11.174, Mozilla's prebuilt legacy build,
 * Apache-2.0). Loads the two files only when a viewer opens. Shared by CaseReportViewer and
 * StoredDocViewer (s101 Phase 3).
 */
const PDFJS_DIR = 'vendor/pdfjs-3.11.174/'
let pdfjsPromise = null

export function loadPdfjs() {
  if (typeof window !== 'undefined' && window.pdfjsLib) return Promise.resolve(window.pdfjsLib)
  if (pdfjsPromise) return pdfjsPromise
  const base = (import.meta.env && import.meta.env.BASE_URL) || '/'
  pdfjsPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script')
    s.src = base + PDFJS_DIR + 'pdf.min.js'
    s.async = true
    s.onload = () => {
      const lib = window.pdfjsLib
      if (!lib) { pdfjsPromise = null; reject(new Error('pdfjs missing')); return }
      lib.GlobalWorkerOptions.workerSrc = base + PDFJS_DIR + 'pdf.worker.min.js'
      resolve(lib)
    }
    s.onerror = () => { pdfjsPromise = null; reject(new Error('pdfjs load')) }
    document.head.appendChild(s)
  })
  return pdfjsPromise
}

